import React from 'react';
import { Spinner } from 'components/atoms';
import { setObjValue } from 'services/utils';
import RemoveButton from 'components/RemoveButton';


function getComparatorForFilter(filterObj) {
  Object.keys(filterObj).forEach(fieldName => {
    if ( isNaN( parseInt(filterObj[fieldName]) ) ) {
      filterObj[fieldName] = filterObj[fieldName].toLowerCase();
    } else {
      filterObj[fieldName] = parseInt(filterObj[fieldName]);
    }
  });
  return function(item) {
    let match = true;
    Object.keys(filterObj).forEach(fieldName => {
      const filterValue = filterObj[fieldName];
      if (match && filterValue !== '') {
        if (typeof(filterValue) === 'string') {
          match = match && item[fieldName] && item[fieldName].toLowerCase().indexOf(filterValue) > -1;  
        } else {
          match = match && typeof(item[fieldName]) !== 'undefined' && item[fieldName] === filterValue;
        }
      }
    });
    return match; 
  }
}

function FilterField({filter, field, onChange}) {
  let {name, label, className} = field;
  const id = 'item' + name;
  className = (className || 'col') + ' mb2';
  return (
    <div className={className}>
      <label htmlFor={id}>{label}</label>
      <input type="text" className="form-control" id={id} name={name} value={filter[name]} onChange={onChange}/>
    </div>
  );
}

const defaultFilterFields = [
  {
    name: 'name',
    label: 'Название',
  },
];

export function BasicFilter({filter, onChange, onClear, fields = defaultFilterFields}) {
  return (
    <form className="col-xl-8 col-lg-10 border p-3 mb-2 rounded shadow-sm">
      <div className="row mb-2">
        <legend>Фильтр</legend>
        {fields.map(field => <FilterField key={field.name} filter={filter} field={field} onChange={onChange} />)}
      </div>
      <button type="button" className="btn btn-warning" onClick={onClear}>Очистить</button>
    </form>
  );
}

export function BasicCrudItem(props) {
  let {item, editHook} = props;
  let edit = () => {
    editHook(item.id);
  }
  return (
    <button onClick={edit} id={item.id} title="Edit" className="list-group-item list-group-item-action">
      <h5>{item.name}</h5>
      <p className="mb-1">{item.path}</p>
    </button>
  );
}

export function BasicCrudItemEdit(props) {
  let {item, updateAttribute, save, cancel, remove, saving} = props;
  return (
    <form id={item.id} className="list-group-item">
      <h3>Редактировать запись</h3>
      <div className="form-group">
        <label htmlFor="itemName">Название</label>
        <input type="text" className="form-control" id="itemName" name="name" value={item.name} onChange={updateAttribute}/>
      </div>
      <div className="form-group">
        <label htmlFor="itemPath">Путь в строке адреса</label>
        <input type="text" className="form-control" id="itemPath" name="path" value={item.path} onChange={updateAttribute}/>
      </div>
      <button type="button" disabled={saving} onClick={save} className="btn btn-primary">
        { (saving && <Spinner />) }
        Сохранить
      </button>
      <button disabled={saving} type="button" onClick={cancel} className="btn btn-default">Отмена</button>
      <RemoveButton disabled={saving} remove={remove} />
    </form>
  );
}


export default class basicCrud extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      filter: {name:''},
      items: [],
      loading: true,
      currentEditedItem: null,
      saving: false,
    };
    this.loadItemsParams = {};
    this.listName = 'Записи';
    this.modelClass = null;
    this.filterFields = [
      {
        name: 'name',
        label: 'Название',
      }
    ];
  }

  componentDidMount() {
    this.loadItems();
  }

  filterUpdateAttribute = (event) => {
    const filterObj = this.state.filter;
    if (filterObj) {
      const value = event.target.value;
      const fieldName = event.target.name;
      filterObj[fieldName] = value;
      this.setState({ filter: filterObj });
    }
  }

  filterClearFields = () => {
    let filterObj = {};
    this.filterFields.forEach(field => {
      filterObj[field.name] = '';
    });
    this.setState({ filter: filterObj });
  }

  editItem = (itemId) => {
    if (this.state.saving) return false;
    this.cancelEditItem();
    this.setState({currentEditedItem: itemId});
  }

  cancelEditItem = () => {
    const item = this.getCurrentItem();
    if (item && item.id < 1) {
      this.removeItemFromList(item.id);
    }
    this.setState({currentEditedItem: null});
  }

  itemUpdateAttribute = (event) => {
    const item = this.getCurrentItem();
    if (item) {
      const value = ['checkbox', 'radio'].includes(event.target.type) ? (event.target.checked || '0') : event.target.value;
      setObjValue(item, event.target.name.split('.'), value);
      this.setState({items: this.state.items});
    }
  }

  updateItem = (updatedItem, isNewItem) => {
    const items = this.state.items;
    let item, i;
    for (i in items) {
      item = items[i];
      if (item.id === updatedItem.id || ((item.id === '' || item.id === 'new') && isNewItem)) {
        items[i] = updatedItem;
        this.setState({items});
        break;
      }
    }
  }

  removeItemFromList = (IdToRemove) => {
    const items = this.state.items.filter((item) => IdToRemove !== item.id);
    this.setState({items});
  }

  addItemAsFirst = () => {
    this.addItem({first:true});
  }

  addItem = ({first=false}) => {
    if (!this.modelClass) return;
    let item = new this.modelClass(this.loadItemsParams);
    const items = this.state.items;
    if (first) {
      items.unshift(item);
    } else {
      items.push(item);
    }
    this.setState({items});
    this.editItem(item.id);
  }

  getCurrentItem = () => {
    if (this.state.currentEditedItem === null) {
      return null;
    }
    const items = this.state.items;
    for (let item of items) {
      if (item.id === this.state.currentEditedItem) {
        return item;
      }
    }
    return null;
  }

  saveCurrentItem = () => {
    this.setState({saving: true});
    const item = this.getCurrentItem();
    const isNewItem = item.id === '' || item.id === 'new';
    item.save().then((updatedItem) => {
      if (updatedItem) {
        this.updateItem(updatedItem, isNewItem);
      } else {
        console.log('Server returned unexpected data in success response');
      }
      this.cancelEditItem();
    }).catch((error) => {
      const errors = error && error.response && error.response.data && error.response.data.errors;
      if (errors) {
        alert(errors.join("\n"));
        return;
      }
      console.log('Error:', error);
    }).then(() => {
      this.setState({saving: false});
    });
  }

  removeCurrentItem = () => {
    const item = this.getCurrentItem();
    if (item) {
      this.removeItem(item);
    }
  }

  removeItem = (item) => {
    this.setState({saving: true});
    item.delete().then((id) => {
      this.removeItemFromList(id);
      this.cancelEditItem();
    }).catch((error) => {
      console.log('Error:', error);
    }).then(() => {
      this.setState({saving: false});
    });
  }

  loadItems() {
    if (!this.modelClass) return;
    this.modelClass.query(this.loadItemsParams).then((result) => {
      this.setState({items: result.items, loading: false});
    }).catch((errors) => {
      this.setState({loading: false, errors});
    });
  }

  filteredItems() {
    const filterObj = {...this.state.filter};
    const items = this.state.items;
    const currentItem = this.getCurrentItem();
    const filterComparator = getComparatorForFilter(filterObj);
    return items.filter((item) => {
      if (item === currentItem) return true;
      let match = filterComparator(item);
      return match;
    });
  }

  renderItem = (item) => {
    if ( this.state.currentEditedItem === item.id ) {
      return <BasicCrudItemEdit item={item}
        key={item.id}
        updateAttribute={this.itemUpdateAttribute}
        save={this.saveCurrentItem}
        cancel={this.cancelEditItem}
        remove={this.removeCurrentItem}
        saving={this.state.saving}
        />
    }
    return <BasicCrudItem item={item} editHook={this.editItem} key={item.id}/>
  }

  render() {
    let newItemExists = this.state.items.some(item => item.id === 'new' || item.id === '');
    let list = this.filteredItems().map(this.renderItem);
    return (
      <div>
        <h2>{this.listName}</h2>
        <BasicFilter filter={this.state.filter} fields={this.filterFields} 
          onChange={this.filterUpdateAttribute} onClear={this.filterClearFields} />
        {this.state.filter.name}
        <div className="button-group mt-2 mb-2">
          <button type="button" disabled={newItemExists} onClick={this.addItemAsFirst} className="btn btn-primary">Добавить</button>
        </div>
        <div className="list-group col-xl-8 col-lg-10 col-md-12">
          {list}
        </div>
        <div className="button-group mt-2">
          <button type="button" disabled={newItemExists} onClick={this.addItem} className="btn btn-primary">Добавить</button>
        </div>
      </div>
    );
  }
}
